import Cookies from 'universal-cookie'
import moment from 'moment'
import { API_HOSTNAME } from '../../GlobalConfig'

import createConstant from '../../utils/createConst'

const GET_CHAT = createConstant('inbox/GET_CHAT')
const SEND_CHAT = createConstant('inbox/SEND_CHAT')

const initialState = {
  modalIsOpen: false,
  popUp: 'login',
  chatRequest: false,
  chatError: '',
  chat: undefined,
  sendChatRequest: false,
  sendChatError: '',
  sendChat: undefined,
}

export default (state = initialState, action) => {
  switch (action.type) {
    case GET_CHAT.request:
      return {
        ...state,
        chatRequest: true,
        chatError: '',
      }
    case GET_CHAT.failed:
      return {
        ...state,
        chatRequest: false,
        chatError: action.error.message,
        chat: undefined,
      }
    case GET_CHAT.success:
      return {
        ...state,
        chatRequest: false,
        chatError: '',
        chat: action.result.result,
      }
    case SEND_CHAT.request:
      return {
        ...state,
        sendChatRequest: true,
        sendChatError: '',
      }
    case SEND_CHAT.failed:
      return {
        ...state,
        sendChatRequest: false,
        sendChatError: action.error.message,
        sendChat: undefined,
      }
    case SEND_CHAT.success:
      return {
        ...state,
        sendChatRequest: false,
        sendChatError: '',
        sendChat: action.success.message,
        chat: state.chat.map((item) => {
          if (item.shopID === action.payload.shopID) {
            return {
              ...item,
              ...{
                chats: [
                  ...item.chats,
                  ...[{
                    type: 'sender',
                    message: action.payload.message,
                    datetime: moment().format('DD/MM/YYYY h:mm:ss'),
                  }],
                ],
              },
            }
          }
          return item
        }),
      }
    default:
      return state
  }
}

const cookie = new Cookies()
const token = cookie.get('TKN_MINAPOLI')

export const getChat = () => (dispatch) => {
  const options = {
    method: 'POST',
    headers: {
      Authorization: `Bearer ${token}`,
    },
    mode: 'cors',
  }

  dispatch({
    types: GET_CHAT,
    promise: fetch(`${API_HOSTNAME}/v1/message`, options),
  })
}

export const sendChat = (message, shopID, chatID = undefined) => (dispatch) => {
  const payload = {
    message,
    shop: shopID,
    chatID,
  }

  const options = {
    method: 'POST',
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
    mode: 'cors',
    body: JSON.stringify(payload),
  }

  dispatch({
    payload,
    types: SEND_CHAT,
    success: {
      message: 'Pesan Anda berhasil di kirim',
    },
    promise: fetch(`${API_HOSTNAME}/v1/shop/message/send`, options),
  })
}



// WEBPACK FOOTER //
// ./src/modules/Inbox/index.js